import { VALUE_UPDATE_EVENT } from "../../lib/constants.js";
import _sfc_main$1 from "./control_selection.vue.js";
import { UNSET } from "../../lib/control.js";
import { computed, createBlock, openBlock, renderSlot, withCtx } from "vue";
//#region src/components/controls/control_nullish.vue
var _sfc_main = /* @__PURE__ */ Object.assign({ name: "DtcControlNullish" }, {
	props: {
		value: {
			type: void 0,
			default: () => null
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},
	emits: [VALUE_UPDATE_EVENT],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const selectionMap = {
			undefined: UNSET,
			null: null
		};
		const selections = computed(() => {
			return Object.keys(selectionMap);
		});
		const selection = computed(() => {
			return Object.keys(selectionMap).find((selection) => {
				return Object.is(props.value, selectionMap[selection]);
			});
		});
		function updateValue(e) {
			emit(VALUE_UPDATE_EVENT, selectionMap[e]);
		}
		return (_ctx, _cache) => {
			return openBlock(), createBlock(_sfc_main$1, {
				value: selection.value,
				"valid-values": selections.value,
				disabled: __props.disabled,
				"onUpdate:value": updateValue
			}, {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
				_: 3
			}, 8, [
				"value",
				"valid-values",
				"disabled"
			]);
		};
	}
});
//#endregion
export { _sfc_main as default };

//# sourceMappingURL=control_nullish.vue.js.map